/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CreatedInputs */

const en_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• Created`)
};

const es_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• Creado`)
};

const fr_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• Créée`)
};

const de_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• Erstellt`)
};

const ja_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• 作成日`)
};

const zh_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• 创建于`)
};

const ar_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• تاريخ الإنشاء`)
};

const id_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• Dibuat`)
};

const it_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• Creato`)
};

const ru_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• Создано`)
};

const pt_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• Criado`)
};

const ko_created = /** @type {(inputs: CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`• 작성일`)
};

/**
* | output |
* | --- |
* | "• Created" |
*
* @param {CreatedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const created = /** @type {((inputs?: CreatedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CreatedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_created(inputs)
	if (locale === "es") return es_created(inputs)
	if (locale === "fr") return fr_created(inputs)
	if (locale === "de") return de_created(inputs)
	if (locale === "ja") return ja_created(inputs)
	if (locale === "zh") return zh_created(inputs)
	if (locale === "ar") return ar_created(inputs)
	if (locale === "id") return id_created(inputs)
	if (locale === "it") return it_created(inputs)
	if (locale === "ru") return ru_created(inputs)
	if (locale === "pt") return pt_created(inputs)
	return ko_created(inputs)
});